import { h } from 'preact';
import { useStyles } from '../../../../common/hooks';
import Position from '../../../../common/utils/Position';
import { CONTENT_FLEX_WITH_GAP } from './styles';

function SlideContent({ children }) {
  const setStyles = useStyles();
  return (
    <div
      className="ftv-slide-content"
      role="listitem"
      style={setStyles({
        default: {
          fontSize: 16,
          height: '100%',
          marginRight: 8,
          ...CONTENT_FLEX_WITH_GAP
        },
        large: { fontSize: 18 }
      })}
    >
      <Position>{children}</Position>
    </div>
  );
}

export default SlideContent;
